import { useTaskGridPreferencesQuery, useUpdateTaskGridPreferencesMutation } from "./queries";
import type { TemplateSortMode } from "../types";

/**
 * Task template (row axis) sort preference, server-persisted alongside the
 * people sort. Default is "custom" so the user's manual drag arrangement
 * sticks until they explicitly switch to an automatic sort.
 */
export default function useTemplateSortMode(): {
  templateSort: TemplateSortMode;
  setTemplateSort: (next: TemplateSortMode) => void;
} {
  const prefsQuery = useTaskGridPreferencesQuery();
  const updatePrefs = useUpdateTaskGridPreferencesMutation();

  const templateSort: TemplateSortMode = prefsQuery.data?.templateSort ?? "custom";

  const setTemplateSort = (next: TemplateSortMode) => {
    if (next === templateSort) return;
    updatePrefs.mutate({ templateSort: next });
  };

  return { templateSort, setTemplateSort };
}
